// client/src/components/common/BankSearchInput.js

import React, { useState, useEffect } from 'react';
import { Search, ChevronDown } from 'lucide-react';
import { useBankSearch } from '../../hooks/useBankSearch';

const BankSearchInput = ({ 
  value = '', 
  onChange, 
  placeholder = 'Cerca e seleziona una banca...', 
  required = false,
  maxResults = 10,
  className = '',
  disabled = false
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const { query, setQuery, filteredBanks, isValidBank } = useBankSearch(value, maxResults);

  // Sincronizza la query solo quando il value esterno cambia (es. reset form)
  useEffect(() => {
    setQuery(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  // Resto del codice rimane uguale...
  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setQuery(newValue);
    // Non chiamare onChange qui - il valore viene impostato solo alla selezione
    // Se l'utente cancella tutto, resetta il valore selezionato
    if (newValue === '') {
      onChange?.('');
    }
    setShowDropdown(true);
  };

  const handleBankSelect = (bank) => {
    setQuery(bank);
    onChange?.(bank);
    setShowDropdown(false);
  };

  const handleInputFocus = () => {
    setShowDropdown(true);
  };

  const handleInputBlur = () => {
    setTimeout(() => {
      setShowDropdown(false);
      // Se il testo digitato non è una banca valida, ripristina il valore selezionato
      if (!isValidBank && query !== value) {
        setQuery(value);
      }
    }, 200);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setShowDropdown(false);
    }
  };

  return (
    <div className={`bank-search-container ${className}`}>
      {/* Resto del JSX rimane uguale */}
      <div className="search-input-wrapper">
        <Search size={16} className="search-icon" />
        <input
          type="text"
          value={query}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          className={`search-input ${!isValidBank && query ? 'invalid' : ''}`}
          autoComplete="off"
        />
        <ChevronDown 
          size={16} 
          className={`dropdown-icon ${showDropdown ? 'rotated' : ''}`} 
        />
      </div>
      
      {showDropdown && !disabled && (
        <div className="bank-dropdown">
          {filteredBanks.length > 0 ? (
            filteredBanks.map((bank, index) => (
              <div
                key={index}
                className="bank-option"
                onClick={() => handleBankSelect(bank)}
                onMouseDown={(e) => e.preventDefault()}
              >
                {bank}
              </div>
            ))
          ) : query.length > 0 ? (
            <div className="bank-option no-results">
              Nessuna banca trovata per "{query}"
            </div>
          ) : (
            <div className="bank-option no-results">
              Digita per cercare una banca...
            </div>
          )}
        </div>
      )}
      
      {/* Stili CSS rimangono uguali */}
    </div>
  );
};

export default BankSearchInput;